// Actions for the My Content per-OBJECT show/hide ("Hide on Map" in each item's
// kebab menu). The state is a list of individual object keys currently HIDDEN
// from the map. Session-only (blacklisted from redux-persist) — resets to
// all-visible on reload, mirroring the per-type toggle (WEB-7044 / WEB-7047).

export const TOGGLE_CONTENT_ID_VISIBILITY = 'TOGGLE_CONTENT_ID_VISIBILITY'
export const CONTENT_IDS_VISIBILITY_RESET = 'CONTENT_IDS_VISIBILITY_RESET'

// A hidden object is keyed by "kind:id" — never the bare id — because markers,
// photos, circles, lines, polygons and tracks come from separate backend tables
// and can share a numeric id. The kind must match the literal used by the
// render-* consumer (marker | photo | circle | line | polygon | track).
export const contentVisibilityKey = (kind, id) => `${kind}:${id}`

export const toggleContentIdVisibility = (kind, id) => ({
  type: TOGGLE_CONTENT_ID_VISIBILITY,
  payload: contentVisibilityKey(kind, id),
})

export const resetContentIdsVisibility = () => ({
  type: CONTENT_IDS_VISIBILITY_RESET,
})
